import { Injectable } from '@angular/core';
import SecureLS from 'secure-ls';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  fromTermsCondition: boolean | undefined;
  isShowCheckbox: boolean | undefined;
  isTermsAccepted: boolean | undefined;
  email: string   | undefined;
  password: string | undefined;
  mode: string | undefined;
  private _ls = new SecureLS({ encodingType: 'aes', isCompression: false });

  private param1: string | null = null;
  private param2: string | null = null;
  constructor() {
  }

  set(key: string, value: any, expired: number = 0) {
    this._ls.set(key, value);
  }


  remove(key: string) {
    this._ls.remove(key);
  }

  get(key: string) {
    return this._ls.get(key);
  }

  clear() {
    this._ls.removeAll();
  }

  setSession(key: string, value: any) {
    sessionStorage.setItem(key, value);
  }

  getSession(key: string) {
    return sessionStorage.getItem(key);
  }

  setOneParams(param1: string, param2: string) {
    this.param1 = param1;
    this.param2 = param2;
  }

  getOneParams() {
    return { param1: this.param1, param2: this.param2 };
  }

  setTwoParams(param1: string, param2: string) {
    this.param1 = param1;
    this.param2 = param2;
  }

  getTwoParams() {
    return { param1: this.param1, param2: this.param2 };
  }

}
